import { Label } from "common/common.styled";
import styled, { keyframes } from "styled-components";

export const Photo = styled.img`
    width: 83px;
    height: 83px;
    border-radius: 20px;
    object-fit: cover;
    border: 1px solid #bdbdbd;
`;

const rotate = keyframes`
    0% {
        transform:rotate(0deg);
    }
    100% {
        transform:rotate(360deg);
    }
`;

export const DeleteIcon = styled.div`
    z-index: 5;
    display: none;
    cursor: pointer;
    position: absolute;
    top: -6px;
    right: -6px;
    background-color: #fff;
    border-radius: 50%;
    border: 1px solid #000;
    padding: 1px;
`;

export const PhotoWrapper = styled.div<{ showLoader: boolean }>`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;

    #loader {
        display: ${({ showLoader }) => (showLoader ? "block" : "none")};
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        animation: ${rotate} 2s linear infinite;
        * {
            fill: ${({ theme }) => theme.colors.purple.primary};
        }
    }

    ${Photo} {
        opacity: ${({ showLoader }) => (showLoader ? "0" : "1")};
    }

    &:hover {
        ${Photo} {
            border: 1px solid ${({ theme }) => theme.colors.purple.primary};
        }
        ${DeleteIcon} {
            display: flex;
            fill: ${({ theme }) => theme.colors.grey.primary};
        }
    }
`;

export const UploadButton = styled(Label)`
    display: flex;
    gap: 10px;
    align-items: center;
    font-weight: 500;
`;
